import { render, staticRenderFns } from "./fichafinanceira.vue?vue&type=template&id=f2402222&scoped=true&"
import script from "./fichafinanceira.vue?vue&type=script&lang=js&"
export * from "./fichafinanceira.vue?vue&type=script&lang=js&"
import style0 from "./fichafinanceira.vue?vue&type=style&index=0&id=f2402222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2402222",
  null
  
)

export default component.exports